/**
 * Слой водоснабжения на холсте: трубы между точками по полу.
 *
 * Трасса каждой трубы считается из положения точек на стенах и её поворотов,
 * поэтому передвинул водорозетку — труба потянулась за ней. Труба, у которой
 * пропала одна из точек, не рисуется (стор такие и не хранит). Черновик
 * прокладываемой трубы рисует холст отдельно — он не часть слоя.
 */
import type { PointerEvent } from "react";
import { pipeRoute, type ItemsLayer, type Pipe, type WallGraph } from "../../plan";
import { PipeShape } from "@/widgets/catalog";
import { SelectionKind, Tool, useEditorStore } from "../../editor";

interface Props {
	graph: WallGraph;
	/** Слой сантехники: концы труб — точки водоснабжения на стенах */
	plumbing: ItemsLayer;
	pipes: Pipe[];
	mmPerPx: number;
	onPipePointerDown: (e: PointerEvent<Element>, pipe: Pipe) => void;
}

export const PipesLayer2D = ({ graph, plumbing, pipes, mmPerPx, onPipePointerDown }: Props) => {
	const selection = useEditorStore((s) => s.selection);
	const tool = useEditorStore((s) => s.tool);
	return (
		<g>
			{pipes.map((pipe) => {
				const route = pipeRoute(graph, plumbing, pipe);
				if (!route) return null;
				return (
					<PipeShape
						key={pipe.id}
						pipeId={pipe.id}
						route={route}
						medium={pipe.medium}
						selected={selection?.kind === SelectionKind.Pipe && selection.id === pipe.id}
						mmPerPx={mmPerPx}
						interactive={tool === Tool.Select || tool === Tool.Erase}
						onPointerDown={(e) => onPipePointerDown(e, pipe)}
					/>
				);
			})}
		</g>
	);
};
